import { render, staticRenderFns } from "./non-motor-vehicle.vue?vue&type=template&id=675c64c3&scoped=true&"
import script from "./non-motor-vehicle.vue?vue&type=script&lang=ts&"
export * from "./non-motor-vehicle.vue?vue&type=script&lang=ts&"
import style0 from "./non-motor-vehicle.vue?vue&type=style&index=0&id=675c64c3&prod&lang=scss&scoped=true&"
import style1 from "./non-motor-vehicle.vue?vue&type=style&index=1&id=675c64c3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c64c3",
  null
  
)

export default component.exports